<template>
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 105 105" :width="width" :height="height" >
		<g transform="translate(-135 -281)">
			<path :class="classOutline"
			      d="M52.5,105A52.514,52.514,0,0,1,32.065,4.126a52.514,52.514,0,0,1,40.871,96.749A52.171,52.171,0,0,1,52.5,105Zm.345-99.156A47.012,47.012,0,0,0,34.55,96.151,47.012,47.012,0,0,0,71.139,9.538,46.706,46.706,0,0,0,52.845,5.845Z"
			      transform="translate(135 281)" />
			<path :class="classFill" d="M47,0A47,47,0,1,1,0,47,47,47,0,0,1,47,0Z" transform="translate(140.844 286.844)"/>
			<path :class="classOutline" d="M89.069,73.427h-22.4L51.893,55,67.908,35.191H88.243L73.036,54.343Z"
			      transform="translate(126.756 279.269)" />
			<path :class="classOutline" d="M20.028,34.936H51.054L36.19,54.32V73.415H20.028Z"
			      transform="translate(138.362 279.363)" />
		</g>
	</svg>
</template>

<script>
	export default {
		name: "SvgImage",
		data() {
			return {

			}
		},
		props: {
			color: {
				type: String,
				default: 'standard'
			},
			width : {
				type : Number,
				default : 100
			},
			height : {
				type : Number,
				default: 100
			}
		},
		computed: {
			classOutline () {
				return 'outline ' + this.color + '-outline';
			},
			classFill () {
				return 'fill ' + this.color + '-fill';
			}
		},
		methods: {}
	}
</script>

<style scoped>
	.outline,
	.fill {
		transition: all .3s ease-out;
	}
	.standard-outline {

		fill: #a1aab3;
	}
	.standard-fill {
		fill: #17181a;
	}
	.red-outline {
		fill: #E4223C;
	}
	.red-fill {
		fill : #17181a;
	}
	.stamp-outline {
		fill: #1D2227;
	}
	.stamp-fill {
		fill : transparent;
	}
</style>


// WEBPACK FOOTER //
// src/components/subparts/SvgImage.vue